import { isNil, values } from 'ramda';
import { useSession } from '../context/SessionProvider';
import { useCheckUserPermissions } from '../services/api/generated/client';
const useCanUserViewFeature = (permissions, resource, strategy = 'all') => {
    const user = useSession();
    const { data, isLoading, isError } = useCheckUserPermissions(user?.id ?? null, {
        permissions: permissions,
        resource,
    }, {
        query: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    });
    if (isLoading) {
        return { isLoading: true, canView: false };
    }
    if (isNil(data) || isError) {
        return { isLoading: false, canView: false };
    }
    if (strategy === 'all') {
        return {
            isLoading: false,
            canView: data.data.has_permission,
            permissions: data.data.permissions,
        };
    }
    return {
        isLoading: false,
        canView: values(data.data.permissions).includes(true),
        permissions: data.data.permissions,
    };
};
export default useCanUserViewFeature;
